<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="请输入分拣框编号" :show-rest="true" @rest="queryCall({code:''})">
    </ScanQuery>
    <el-button type="primary" slot="customize" @click="addBasket" style="float:left;margin-bottom:10px;">
      新建
    </el-button>
    <div style="clear:both"></div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
      <div
        slot="action"
        slot-scope="{ text, record, index }"
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <!-- <a href="javascript:;" @click="edit(record)">编辑</a>
        <a href="javascript:;" style="color: orangered" @click="del(record)">删除</a> -->
        <el-switch
          v-model="record.useable"
          active-color="#008dde"
          inactive-color="#eeeeee"
          @change="switchChange(record, index)"
          :disabled="record.useStatus"
        ></el-switch>
      </div>
    </WmsTable>
    <SetBasket ref="setBasket" @submitBasket="submitBasketCall" @batchBasket="batchBasketCall"/>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import SetBasket from "@/views/configure/basket/components/SetBasket";
import { columns } from "@/views/configure/basket/indexData";
import { basketDel, basketPageGet, setBasket,batchAddBox } from "@/apis/configure";

export default {
  name: "ConfigureBasket",
  components: {
    ScanQuery,
    SetBasket,
    WmsTable,
  },
  data() {
    return {
      query: {
        code: "",
        current: 1,
        pageSize: 10,
        total: 0,
      },
      columns,
      dataSource: [],
    };
  },
  mounted() {
    this.getDataSource();
  },
  watch:{
    $route: {
      handler:function (newVal) {
        const {params} = newVal
        if(params.openAdd) {
          this.$nextTick(()=>{
            this.$refs["setBasket"].open('新建分拣框',2);
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    queryCall: function (payload) {
      this.query.current = 1
      this.query.code = payload.code;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.getDataSource();
    },
    getDataSource: function () {
      const that = this;
      const params = {
        basketCode: that.query.code,
        pageNum: that.query.current,
        pageSize: that.query.pageSize,
      };
      basketPageGet(params).then(({ code, data }) => {
        if (code === 0) {
          const { records, total } = data;
          records.forEach(item => {
            item.useStatus = item.useStatus==0?false:true
            item.useable = item.useable?true:false
          })
          that.dataSource = records;
          that.query.total = total;
        }
      });
    },
    addBasket: function () {
      this.$refs["setBasket"].open('新建分拣框');
    },
    submitBasketCall: function (payload, index) {
      setBasket(payload)
        .then(({ code }) => {
          if (code === 0) {
            this.$message.success("成功");
            this.getDataSource();
          } else {
            if (index) {
              this.dataSource[index].useable = !this.dataSource[index].useable;
            }
          }
        })
        .catch();
    },
    batchBasketCall:function(payload){
      batchAddBox({
        prefix: payload.basketAffix,
        basketType: payload.basketType,
        num:payload.basketCount
      }).then(({code})=>{
          if(code === 0){
            this.$message.success("成功");
            this.getDataSource();
          }
        })
    },
    switchChange(record, index) {
      let prams = {
        basketCode: record.basketCode,
        basketId: record.basketId,
        basketType: record.basketType,
        useStatus: record.useStatus ? 1: 0,
        useable: record.useable ? 1 : 0,
      };
      this.submitBasketCall(prams, index);
    },
    edit: function (r) {
      this.$refs["setBasket"].open(r);
    },
    del: function (r) {
      // TODO 删除篮子
      basketDel({ basketCode: r.basketCode });
    },
  },
};
</script>

<style scoped></style>
